import React from 'react';
import { IDashboardTemplateFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { DashboardNavSectionType } from '../../types';
import { DashboardTemplate } from '../components';

interface IProps {
  templates: IDashboardTemplateFieldsFragment[];
  mouseOverId: string | null;
  setMouseOverId: (mouseOverId: string | null) => void;
  openedMenuId: string | null;
  setOpenedMenuId: (mouseOverId: string | null) => void;
}

const PublishedDashboardTemplates = ({
  templates,
  mouseOverId,
  setMouseOverId,
  openedMenuId,
  setOpenedMenuId,
}: IProps) => {
  return (
    <>
      {templates.map((template) => (
        <DashboardTemplate
          key={`${DashboardNavSectionType.Published}-${template.baseId}`}
          template={template}
          variant={DashboardNavSectionType.Published}
          mouseOverId={mouseOverId}
          setMouseOverId={setMouseOverId}
          openedMenuId={openedMenuId}
          setOpenedMenuId={setOpenedMenuId}
        />
      ))}
    </>
  );
};

export default PublishedDashboardTemplates;
